import { CUSTOM_EMOJI_EXACT_RE } from '@clanfire/shared';
import { cn } from '@/lib/utils';
import { useServers } from '@/stores/servers';

/**
 * A server's own emoji. Shown as :name: when it's unknown here (deleted, or
 * from a server you're not in).
 */
export function CustomEmoji({ id, name, className, fallbackUrl }: { id: string; name: string; className?: string; fallbackUrl?: string | null }) {
  // From one of your servers, or sent with the message (Blaze) when it's from a server you're not in.
  const url = useServers((s) => s.emojis[id]?.url) ?? fallbackUrl ?? undefined;
  if (!url) return <span className={className}>:{name}:</span>;
  return <img src={url} alt={`:${name}:`} title={`:${name}:`} loading="lazy" decoding="async" draggable={false} className={cn('inline-block h-[1.375em] w-[1.375em] object-contain align-[-0.3em]', className)} />;
}

/** A Unicode emoji or a custom emoji token (as used in reactions). */
export function EmojiGlyph({ emoji, className }: { emoji: string; className?: string }) {
  const custom = CUSTOM_EMOJI_EXACT_RE.exec(emoji);
  if (custom) return <CustomEmoji id={custom[2]!} name={custom[1]!} className={className} />;
  return <span className={className}>{emoji}</span>;
}

/** A readable name for an emoji token: the emoji itself, or :name: for custom ones. */
export function emojiLabel(emoji: string): string {
  const custom = CUSTOM_EMOJI_EXACT_RE.exec(emoji);
  return custom ? `:${custom[1]}:` : emoji;
}
